import { ONE } from 'config/apis'
import { getCachedRequest } from 'utils/cache'

const getFedData = async (data) => {
  const { user, token } = data
  const headersWithPass = { ...ONE.HEADERS }
  headersWithPass.headers.token = token
  try {
    const req = await fetch(ONE.PRIVATE_DATA.replace('{id}', user), {
      method: 'GET',
      ...headersWithPass
    })
    const parsed = await req.json()
    return parsed?.Data || parsed
  } catch (err) {
    console.log(err)
  }
}

const doFetch = async ({ user, club, token, endpoint, queryString = '' }) => {
  const headersWithPass = { ...ONE.HEADERS }
  headersWithPass.headers.token = token
  try {
    const req = await fetch(
      `${ONE[endpoint].replace('{id}', user || club)}${queryString}`,
      {
        method: 'GET',
        ...headersWithPass
      }
    )
    const parsed = await req.json()
    return parsed?.Data || parsed
  } catch (err) {
    console.log(err)
  }
}

export async function getRequest(params) {
  const key = `${params.club || params.user}-${params.endpoint}${
    params.queryString ? `-${params.queryString}` : ''
  }`
  return getCachedRequest(key, () => doFetch(params))
}

const deleteRequest = async ({
  user,
  token,
  endpoint,
  formData,
  queryString = ''
}) => {
  const headersWithPass = { ...ONE.HEADERS }
  headersWithPass.headers.token = token
  try {
    const req = await fetch(
      `${ONE[endpoint].replace('{id}', user)}${queryString}`,
      {
        method: 'POST',
        body: JSON.stringify(formData),
        ...headersWithPass
      }
    )
    const parsed = await req.json()
    return parsed?.Data || parsed
  } catch (err) {
    console.log(err)
  }
}

const sendForm = async ({
  user,
  club,
  token,
  endpoint,
  formData,
  queryString = ''
}) => {
  const headersWithPass = { ...ONE.HEADERS }
  headersWithPass.headers.token = token
  try {
    const req = await fetch(
      `${ONE[endpoint].replace('{id}', user || club)}${queryString}`,
      {
        method: 'POST',
        body: JSON.stringify(formData),
        ...ONE.HEADERS
      }
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

const getVirtualLicense = async (data) => {
  const { user, token, action } = data
  const headersWithPass = { ...ONE.HEADERS }
  headersWithPass.headers.token = token
  try {
    const req = await fetch(
      ONE.PRIVATE_VIRTUAL.replace('{id}', user).replace('{action}', action),
      ONE.HEADERS
    )
    const parsed = await req.json()
    return parsed
  } catch (err) {
    console.log(err)
  }
}

export { getFedData, getRequest, sendForm, deleteRequest, getVirtualLicense }
